// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"47c74d6f","388":"2099388b"}[chunkId] + ".chunk.js";
};